import React from 'react';
import {
    Box,
    Paper
} from '@mui/material';

import { useTranslation } from "react-i18next";
import CrmButton from '../../../../UI/Crm/CrmButton/CrmButton';

const ToolboxHeader = ({ onSave, onRestore }) => {
    const [t] = useTranslation('crm')
    return (
        <Paper sx={{ p: 2, mb: 0,mt:2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', bgcolor: '#f6f6f6',height:60,justifyContent :'flex-end' }}>
            <Box sx={{ display: 'flex', gap: 2 }}>
                {/* <CrmButton variant="contained" color="primary" onClick={onSave}>
                    {t('Save')}
                </CrmButton> */}
                <CrmButton color="crmContainedGray94" onClick={onSave}>
                    {t('Save')}
                </CrmButton>
                {/* <CrmButton variant="outlined" color="primary" onClick={onRestore}>
                    {t('Back')}
                </CrmButton> */}
                <CrmButton color="crmOutlinedGray94" onClick={onRestore}>
                    {t('Back')}
                </CrmButton>
            </Box>
        </Paper>
    )
}

export default ToolboxHeader